<template>
    <validation-observer ref="form" v-slot="{ handleSubmit, meta }">
        <modal
            :id="modalId"
            :title="title"
            ok-title="Save"
            :ok-disabled="!meta.valid || loading"
            @ok.prevent="handleSubmit(_, save)"
            @hide="hideModal"
        >
            <busy-modal :show="loading" :overlay="true"></busy-modal>
            <b-form @submit.prevent="handleSubmit(_,save)" v-if="values">
                <b-row>
                    <b-col>
                        <validation-provider name="name" v-slot="{ errors, handleChange }" rules="required" >
                            <form-input
                                label="Name:"
                                type="text"
                                v-model="values.name"
                                :error="errors[0]"
                                @input="handleChange"
                            ></form-input>
                        </validation-provider>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <validation-provider name="model_id" v-slot="{ errors, handleChange }" rules="required" >
                            <form-select
                                label="Model:"
                                v-model="values.model_id"
                                :options="modelOptions"
                                :error="errors[0]"
                                @change="handleChange"
                            ></form-select>
                        </validation-provider>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <validation-provider name="mac" v-slot="{ errors, handleChange }" rules="required" >
                            <form-input
                                label="Serial #:"
                                type="text"
                                v-model="values.mac"
                                :error="errors[0]"
                                @input="handleChange"
                            ></form-input>
                        </validation-provider>
                    </b-col>
                </b-row>
            </b-form>
        </modal>
    </validation-observer>
</template>
<script>
    import { formatResponseError } from '../../../../../utils/api';
    import Modal from '../../../../generic/modal/modal.vue';
    import FormInput from '../../../../generic/form-input/form-input.vue';
    import FormSelect from '../../../../generic/form-select/form-select.vue';
    import BusyModal from '../../../../generic/busy-modal/busy-modal.vue';

    export default {
        name: 'ResortLockLockDetailModalForm',
        components: {
            BusyModal,
            Modal,
            FormInput,
            FormSelect,
        },
        props: {
            modalId: String,
            create: {
                type: Function,
                default: () => Promise.resolve()
            },
            update: {
                type: Function,
                default: () => Promise.resolve()
            },
            initialValues: {
                type: Object,
                default: () => ({})
            },
        },
        computed: {
            title() {
                return this.initialValues.id
                    ? 'Edit Lock'
                    : 'Add Lock';
            },
            modelOptions() {
                const options = [];
                if (this.initialValues.id) {
                    options.push({ value: null, text: 'Not set' });
                }
                options.push(...[
                    { value: 3, text: 'ResortLock RL2000 Lock' },
                    { value: 4, text: 'ResortLock RL4000 Heavy Duty Lock' }
                ]);
                return options;
            },
        },
        mounted() {
            this.values = this.getInitialValues();
            this.$refs.form.setValues(this.values);
        },
        data() {
            return {
                loading: false,
                values: null,
            }
        },
        methods: {
            hideModal() {
                this.$bvModal.hide(this.modalId);
            },
            getInitialValues() {
                return {
                    id: this.initialValues.id || null,
                    mac: this.initialValues.mac || '',
                    name: this.initialValues.name || '',
                    model_id: this.initialValues.model_id || (this.initialValues.id ? null : 3),
                }
            },
            async save() {
                this.loading = true;

                try {
                    const response = await (this.values.id ? this.update(this.values) : this.create(this.values));
                    this.$emit('success-save', response.data);
                    this.hideModal();
                } catch (err) {
                    const { generic } = formatResponseError(err);
                    this.errorToast({text: generic || `Could not save lock.`})
                } finally {
                    this.loading = false;
                }
            },
        },
        watch: {
            initialValues() {
                this.values = this.getInitialValues();
            },
        }
    }
</script>